/**************************************************
 * toB
 **************************************************/
  const tob = {
  common: {},
  top: {},
  itemList: {},
  itemDetail: {},
  cart: {},
};

/**
* ヘッダーのおすすめアイテム
*/
tob.common.recommendSlider = function() {
  const mySwiper = new Swiper('.js-header-recommend', {
    slidesPerView: 2.6,
    freeMode: {
      enabled: true,// 自由にドラッグ（スワイプ）できるようにする
    },
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    }
  });
};

/**
* 一括カート追加の際に、カート更新のダイアログを表示
*/
tob.common.cartUpdatePopup = function() {
  const itemCount = document.querySelector('.header__icon--cart');// カート内数量
  const updatedPopup = document.getElementById('cart-updated-popup');// 「カート更新しました」のダイアログ
  
  if (!updatedPopup){
    return;
  }

  // 監視の設定
  const observer = new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
      console.log(itemCount);
      // 数量が書き換わったら実行
      showCartPopup();
    });
  });

  // 監視開始（子要素とデータ両方をチェック）
  observer.observe(
    itemCount, { 
      childList: true, 
      characterData: true, 
      subtree: true 
    }
  );

  function showCartPopup() {
    updatedPopup.classList.add('cart-popup-visible');
    updatedPopup.classList.remove('cart-popup-hidden');

    // 3秒後に自動で消す
    setTimeout(() => {
      updatedPopup.classList.remove('cart-popup-visible');
      updatedPopup.classList.add('cart-popup-hidden');
    }, 3000);
  }
}

/**
 * ロゴ縮小の制御
 */
tob.common.headerLogoShrink = function() {
  // 設定値の変数化
  const config = {
    shrinkRatio: 0.7,   // スクロール時のロゴ画像の縮小率
    threshold: 50,      // スクロール量のしきい値（px）
  };

  // ヘッダーロゴ画像
  const logo = document.querySelector('.header__heading-logo');
  if (!logo) {
    return;
  }

  // 1. ページ読み込み時点のロゴの物理的な高さを取得（絶対値を排除）
  const originalHeight = logo.offsetHeight;

  window.addEventListener('scroll', () => {
    // 2. 50px以上スクロールしたら縮小、戻ったら元の高さへ
    if (window.scrollY > config.threshold) {
      logo.style.height = `${originalHeight * config.shrinkRatio}px`;
    } else {
      logo.style.height = `${originalHeight}px`;
    }
  });
}

/**
 * 商品リストで、スウォッチ画像をスライド
 */
tob.common.cardProductSlider = function() {
  if (typeof Swiper !== 'undefined') {
    const swiperElements = document.querySelectorAll('.js-card-variant-swiper');
    
    swiperElements.forEach(function(el) {
      // data属性から画像の枚数を数値として取得
      const totalItems = parseInt(el.dataset.totalImages || '0', 10);

      new Swiper(el, {
        slidesPerView: totalItems > 2 ? 2.6 : 2,
        spaceBetween: 5,
        freeMode: {
          enabled: totalItems > 2
        },
        navigation: {
          nextEl: el.querySelector('.swiper-button-next'),
          prevEl: el.querySelector('.swiper-button-prev'),
        },
        breakpoints: {
          // PCで5カラー以上のときスライダー化
          [illm.common.breakpoint.pc]: {
            slidesPerView: 4,
            freeMode: { enabled: totalItems > 4 }
          }
        }
      });
    });
  }
}


/**
 * メインビジュアルのスライダー
 */
tob.top.mainvisual = function() {
  const slideAutoplay = Boolean($('#illm-slide_autoplay').attr('date-info'));//自動再生: true
  const slideAutoplaySpeed = parseInt($('#illm-slide_autoplay_speed').attr('date-info'));//自動再生時の静止時間: 4000ms
  const slideSpeed = parseInt($('#illm-slide_speed').attr('date-info'));//スライドアニメーションの速度: 600ms
  const slideArrow = Boolean($('#illm-slide_arrow').attr('date-info'));//左右矢印の表示: true
  const slideDot = Boolean($('#illm-slide_dot').attr('date-info'));//ドットの表示: true
  const slideTarget = document.querySelector('.js-home-visual-swiper');//対象のスライド

  // スライドが1枚なら Swiper 自体不要
  const slideCount = slideTarget.querySelectorAll('.swiper-slide').length;
  if (slideCount <= 1) {
    return;
  }

  // Swiper初期化
  const homeVisualSwiper = new Swiper(slideTarget, {
    slidesPerView: 1,
    speed: slideSpeed,
    // 自動再生
    autoplay: slideAutoplay ? {
      delay: slideAutoplaySpeed,
    } : false,
    allowTouchMove: true,
    loop: slideCount > 1,
    // ナビゲーション（矢印）
    navigation: slideArrow ? {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    } : false,
    // ページネーション（ドット）
    pagination: slideDot ? {
      el: ".swiper-pagination",
      clickable: true,
    } : false,
  });
};

/**
 * 印刷ボタンのイベント登録および日付の初期表示
 */
tob.itemList.initPrint = function() {
  const printBtnContainer = document.querySelector('.js-btn-print-wrapper');
  const printBtn = document.querySelector('.js-btn-print');
  if (!printBtn) {
    return;
  }

  // 日付の初期セット (MM/DD/YYYY)
  const today = new Date();
  const mm = String(today.getMonth() + 1).padStart(2, '0');
  const dd = String(today.getDate()).padStart(2, '0');
  const yyyy = today.getFullYear();
  
  const printDateEl = document.getElementById('print-date');
  if (printDateEl) {
    printDateEl.innerText = `Date Printed ${mm}/${dd}/${yyyy}`;
  }

  // クリックイベント設定
  printBtn.addEventListener('click', () => {
    // ページ内のすべての遅延読み込み画像を即時読み込み（eager）に変更
    const lazyImages = document.querySelectorAll('img[loading="lazy"]');
    lazyImages.forEach(img => {
      img.setAttribute('loading', 'eager');
      // 必要に応じてデータ属性（data-src等）からの入れ替え処理も行う
      if (img.dataset.src) {
        img.src = img.dataset.src;
      }
    });

    setTimeout(() => {
      window.print();
    }, 1000); // 状況に応じてミリ秒数を調整
  });

  // 最後に印刷ボタンを表示
  printBtnContainer.classList.remove('hidden');
}


/**
 * 個別設定__Storefront APIを使用した納期目安の一括更新処理
 */
tob.cart.updateDeliveryDateWithStorefront = async function() {
  // Liquid側で作成した更新対象を確認
  const updates = window.tob?.deliveryUpdates;
  if (!updates || Object.keys(updates).length === 0) {
    console.log('【納期更新】更新対象はありません。');
    return true;
  }

  // Shopify接続情報を取得
  const {shopDomain,storefrontToken,apiVersion: configVersion} = window.tob?.config || {};
  // APIバージョン
  const apiVersion = configVersion || '2026-07';

  // 画面操作をロック
  lockCartScreen();
  
  try {
    // ----------------------------------------
    // 設定チェック
    // ----------------------------------------
    if (!shopDomain || !storefrontToken) {
      console.error(
        '【エラー】ShopifyドメインまたはStorefront APIトークンが設定されていません。'
      );
      return false;
    }

    // ----------------------------------------
    // Liquid側で作成した更新対象
    // ----------------------------------------
    const updates = window.tob?.deliveryUpdates;
    console.log(
      '【納期更新】Liquid更新対象:',
      updates
    );

    if (!updates || Object.keys(updates).length === 0) {
      console.log('【納期更新】更新対象はありません。');
      return true;
    }

    // ----------------------------------------
    // Storefront API endpoint
    // ----------------------------------------
    const endpoint =
      `https://${shopDomain}/api/${apiVersion}/graphql.json`;

    const headers = {
      'Content-Type': 'application/json',
      'X-Shopify-Storefront-Access-Token': storefrontToken
    };

    // ========================================
    // STEP 1
    // 現在のStorefront Cart IDを取得
    // ========================================
    const ajaxCartResponse = await fetch('/cart.js');
    const ajaxCart = await ajaxCartResponse.json();

    if (!ajaxCart.token) {
      console.error(
        '【エラー】Dawnカートのtokenが取得できません。'
      );
      return false;
    }

    const cartId = `gid://shopify/Cart/${ajaxCart.token}`;

    // ========================================
    // STEP 2
    // Storefront APIからCartLineを取得
    // ========================================
    // CartLine取得用GraphQLクエリ
    // 250件を超える場合があるため、pageInfoを取得してページネーションで全CartLineを取得
    const getCartQuery = `
      query getCart($cartId: ID!, $after: String) {
        cart(id: $cartId) {
          id
          totalQuantity

          lines(first: 250, after: $after) {
            edges {
              node {
                id
                quantity

                merchandise {
                  ... on ProductVariant {
                    id
                  }
                }

                attributes {
                  key
                  value
                }
              }
            }

            pageInfo {
              hasNextPage
              endCursor
            }
          }
        }
      }
    `;

    let cartLines = [];// 取得したCartLineをすべて格納する配列
    let after = null;// 次のページを取得するためのカーソル
    let hasNextPage = true;// 次のページが存在するかどうか

    // 次のページがなくなるまで繰り返す
    while (hasNextPage) {
      // Storefront APIへCart情報を取得
      const cartResponse = await fetch(endpoint, {
        method: 'POST',
        headers,
        body: JSON.stringify({
          query: getCartQuery,
          variables: {
            cartId,
            after
          }
        })
      });

      // APIレスポンスをJSONとして取得
      const cartData = await cartResponse.json();

      if (cartData.errors) {
        console.error(
          '【Storefront API エラー】',
          cartData.errors
        );
        return false;
      }

      // Cart存在チェック
      const cart = cartData.data?.cart;

      if (!cart) {
        console.error(
          '【エラー】Storefront APIのCartが存在しません。',
          cartId
        );
        return false;
      }

      // 今回取得したCartLineを取得
      const linesData = cart.lines;

      // 今回取得したCartLineを全CartLineを格納する配列に追加
      cartLines.push(
        ...(linesData?.edges?.map(edge => edge.node) || [])
      );

      // 次のページがあるか確認
      hasNextPage = linesData?.pageInfo?.hasNextPage || false;
      // 次のページを取得するためのカーソルを保存
      after = linesData?.pageInfo?.endCursor || null;
    }

    // CartLine全件取得完了
    console.log(
      '【納期更新】Storefront CartLine数:',
      cartLines.length
    );
    // ========================================
    // STEP 3
    // CartLineとLiquid側の商品を照合
    // ========================================
    const lines = [];
    Object.entries(updates).forEach(
      ([itemKey, data]) => {
        const variantId =
          String(data.variantId);

        // Storefront APIの
        // gid://shopify/ProductVariant/123456
        // から数字部分を取得
        const matchedLine = cartLines.find(line => {
          const merchandiseId =
            line.merchandise?.id || '';
          const storefrontVariantId =
            merchandiseId.split('/').pop();
          return (
            storefrontVariantId === variantId
          );
        });

        if (!matchedLine) {
          console.warn(
            '【警告】CartLineが見つかりません。',
            {
              itemKey,
              variantId,
              quantity: data.quantity
            }
          );
          return;
        }

        // CartLine.idを使って更新データ作成
        lines.push({
          id: matchedLine.id,

          attributes:
            Object.entries(
              data.properties || {}
            ).map(([key, value]) => ({
              key: String(key),
              value: String(value ?? '')
            }))
        });

      }
    );


    // ========================================
    // STEP 4
    // 更新対象チェック
    // ========================================

    if (lines.length === 0) {
      console.error(
        '【エラー】更新対象のCartLineが1件も見つかりませんでした。'
      );
      console.error(
        'Storefront Cart:',
        cart
      );
      console.error(
        'Liquid updates:',
        updates
      );
      return false;
    }

    // ========================================
    // STEP 5
    // cartLinesUpdate
    // ========================================
    const mutation = `
      mutation cartLinesUpdate(
        $cartId: ID!,
        $lines: [CartLineUpdateInput!]!
      ) {
        cartLinesUpdate(
          cartId: $cartId,
          lines: $lines
        ) {
          cart {
            id

            lines(first: 250) {
              edges {
                node {
                  id
                  quantity

                  merchandise {
                    ... on ProductVariant {
                      id
                    }
                  }

                  attributes {
                    key
                    value
                  }
                }
              }
            }
          }

          userErrors {
            field
            message
          }

          warnings {
            code
            message
          }
        }
      }
    `;

    const response = await fetch(endpoint, {
      method: 'POST',
      headers,
      body: JSON.stringify({
        query: mutation,
        variables: {
          cartId,
          lines
        }
      })
    });

    const result = await response.json();
    console.log('【納期更新】cartLinesUpdate結果:',result);


    // ========================================
    // STEP 6
    // GraphQLエラー
    // ========================================
    if (result.errors) {
      console.error(
        '【Storefront API GraphQLエラー】',
        result.errors
      );
      return false;
    }

    const updateResult = result.data?.cartLinesUpdate;

    // ========================================
    // STEP 7
    // Shopify userErrors
    // ========================================
    if (updateResult?.userErrors && updateResult.userErrors.length > 0) {
      console.error(
        '【Storefront API userErrors】',
        updateResult.userErrors
      );
      return false;
    }

    // ========================================
    // STEP 8
    // 更新成功
    // ========================================
    console.log(
      '【成功】納期目安を一括更新しました。',
      updateResult?.cart
    );
    return true;
  } catch (error) {
    console.error(
      '【通信エラー】納期目安更新:',
      error
    );
    return false;
  } finally {
    // 画面操作ロックを解除
    unlockCartScreen();
  }
};

// ラインアイテムプロパティを更新中は画面操作をロック
function lockCartScreen() {
  // すでにロックされていたら何もしない
  if (document.querySelector('.cart-loading-overlay')) {
    return;
  }
  const overlay = document.createElement('div');
  overlay.className = 'cart-loading-overlay';

  const spinner = document.createElement('div');
  spinner.className = 'cart-loading-spinner';

  overlay.appendChild(spinner);
  document.body.appendChild(overlay);
}

// 更新完了したらロック解除
function unlockCartScreen() {
  const overlay = document.querySelector('.cart-loading-overlay');
  if (overlay) {
    overlay.remove();
  }
}

/**
 * 個別設定__カート内をクリア
 */
tob.cart.clearAllCartItems = function (button){
  if (!confirm('カート内のすべての商品を削除してもよろしいですか？')) {
    return;
  }

  // ボタンをローディング状態にする（連打防止）
  button.disabled = true;
  button.style.opacity = '0.5';

  fetch(window.Shopify.routes.root + 'cart/clear.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    }
  })
  .then(response => {
    if (response.ok) {
      // 削除成功後、ページをリロードしてカート状態を更新
      window.location.reload();
    } else {
      alert('エラーが発生しました。時間を置いて再度お試しください。');
      button.disabled = false;
      button.style.opacity = '1';
    }
  })
  .catch(error => {
    console.error('Error:', error);
    alert('エラーが発生しました。');
    button.disabled = false;
    button.style.opacity = '1';
  });
}

/*
* ========================================
* 初期処理
* ========================================
*/
window.addEventListener('load', function () {
// ----------------------------------------
  // Common
  // ----------------------------------------  
  // ヘッダーのおすすめアイテムのスライダー
  if (document.querySelector('.js-header-recommend')) {
    tob.common.recommendSlider();
  }

  // 一括カート追加の際に、カート更新のダイアログを表示
  if (document.querySelector('quick-add-bulk')) {
    tob.common.cartUpdatePopup();
  }

  // ロゴ縮小の制御
  if (document.querySelector('.header__heading-logo')) {
    // tob.common.headerLogoShrink();
  }

  // 商品リストで、スウォッチ画像をスライド
  if (document.querySelector('.js-card-variant-swiper')) {
    tob.common.cardProductSlider();
  }

  // ----------------------------------------
  // Top
  // ----------------------------------------
  if (document.querySelector('.page-index')) {
    // メインビジュアルのスライダー
    if (document.querySelector('.js-home-visual-swiper')) {
      tob.top.mainvisual();
    }
  }

  // ----------------------------------------
  // Collection 
  // ----------------------------------------
  if (document.querySelector('.page-collection')) {
    // 個別設定__印刷ボタンのイベント登録および日付の初期表示
    if (document.querySelector('.js-btn-print')) {
      tob.itemList.initPrint();
    }
  }

});

// DOM読み込み後
document.addEventListener('DOMContentLoaded', function () {
  // ----------------------------------------
  // Cart
  // ----------------------------------------
  if (document.querySelector('.page-cart')) {
    // 個別設定__Storefront API を使用した納期目安の一括更新処理
    tob.cart.updateDeliveryDateWithStorefront();
  }

});